// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { confluxESpace as _confluxESpace } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the confluxESpace chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 1030
 * Chain Name: Conflux eSpace
 * Default Block Explorer: https://evm.confluxscan.io
 * Default RPC URL: https://evm.confluxrpc.com
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { confluxESpace } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: confluxESpace,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const confluxESpace = createCommon({
	..._confluxESpace,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
